import { ModelConfig } from "./main";
import { Dealer } from "./model";
import { Offer } from "./offer";
import { ModalTrimModuleDetailsTranslations } from "./translations";
import { ContentLayerProps } from "@ngw6/us-components";

export enum ModalDisplayMode {
  'TRIM_MODULE_DETAILS' = 'trim_module_details',
}

export interface ModalDisplay {
  active: boolean;
  mode?: ModalDisplayMode;
}
export enum ModalDisplayAction {
  'DISPLAY_MODAL' = 'display modal',
  'CLOSE_MODAL' = 'close modal',
}
export interface ModalDisplayReducer {
  action: ModalDisplayAction;
  mode?: ModalDisplayMode;
}


export interface TrimModuleDetailsLayerState extends ContentLayerProps {
  readonly text: string;
  readonly index: number;
  readonly dealer?: Dealer,
  readonly offer?: Offer,
  readonly translations: ModalTrimModuleDetailsTranslations;
  readonly urlRedirect?: string;
  readonly onCloseHandler?: () => void; 
  readonly onLoadHandler?: () => void; 
  readonly model?: ModelConfig;
}
